import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Box,
  Text,
  Flex,
  Image,
  Button,
  VStack,
  Checkbox,
  useDisclosure,
} from "@chakra-ui/react";

import logo from "../../assets/svgs/logo.svg";
import img1 from "../../assets/four-kids.png";
import RequestModal from "./Modal";

const AuthTermsAndConditions = () => {
  const navigate = useNavigate();
  const [isChecked, setIsChecked] = useState(false);
  const {
    isOpen: isModalOpen,
    onOpen: onModalOpen,
    onClose: onModalClose,
  } = useDisclosure();

  return (
    <>
      <Flex
        justify="center"
        align="center"
        height="100vh"
        bg="white"
        border="1px solid #2a4567"
        position="relative"
        boxShadow="0px 4px 20px rgba(0, 0, 0, 0.25)"
      >
        {/* Left Content */}
        <Box
          flex={1}
          justifyContent="center"
          alignItems="center"
          display={"flex"}
        >
          <VStack align="flex-center" spacing={6} width={480} height={640}>
            <Image src={logo} height={"110px"} />
            <Text
              fontFamily={"PlusJakartaSansMedium"}
              fontSize={"36px"}
              lineHeight={"38px"}
              color={"#000000"}
              textAlign={"center"}
              my={2}
            >
              Terms & Conditions
            </Text>

            <VStack
              align="flex-center"
              spacing={2}
              overflowY="auto" // Enable vertical scrolling
              // p={4} // Optional padding for better spacing
            >
              <Text
                fontFamily={"PlusJakartaSansSemiBold"}
                fontSize={"24px"}
                lineHeight={"32px"}
                color={"#000000"}
                textAlign={"center"}
                textTransform={"capitalize"}
                marginTop={2}
              >
                REGISTRATION
              </Text>
              <Text
                fontFamily={"PlusJakartaSansRegular"}
                fontSize={"14px"}
                color={"#000000"}
                textAlign={"center"}
                marginTop={3}
              >
                All sellers are pre-approved and authorised by Kidswear
                Collective. Sellers can either send items to our business
                premises or we can arrange collection. A collection fee of £5.95
                will be deducted from the seller’s account balance.
              </Text>
              <Text
                fontFamily={"PlusJakartaSansRegular"}
                fontSize={"14px"}
                color={"#000000"}
                textAlign={"center"}
                marginTop={3}
              >
                Accepted items include designer baby, boys and girls wear from
                newborn to 14 years, in addition to shoes and accessories. As a
                guideline, a typical item would have had a minimum retail price
                of at least £40 or higher.
              </Text>
              <Text
                fontFamily={"PlusJakartaSansRegular"}
                fontSize={"14px"}
                color={"#000000"}
                textAlign={"center"}
                marginTop={3}
              >
                Pre-worn (also known as pre-loved) items must be in pristine
                condition or gently worn with no visible signs of wear. We do
                not accept items with stains, tears or worn or over washed
                fabric. Unworn (also known as past season) items must include
                their original tags.
              </Text>
              {/* ITEM CONSIGNMENT */}
              <Text
                fontFamily={"PlusJakartaSansSemiBold"}
                fontSize={"24px"}
                lineHeight={"32px"}
                color={"#000000"}
                textAlign={"center"}
                textTransform={"capitalize"}
                marginTop={8}
              >
                ITEM CONSIGNMENT
              </Text>
              <Text
                fontFamily={"PlusJakartaSansRegular"}
                fontSize={"14px"}
                color={"#000000"}
                textAlign={"center"}
                marginTop={3}
              >
                All pre-worn items received by Kidswear Collective are inspected
                for wear and tear and stains, as well as suitability. Rejected
                items will be sent to our charity partners, unless otherwise
                requested and returned to the seller. A return fee of £2.95 per
                item will be deducted from the seller’s account balance at
                Kidswear Collective.
              </Text>
              <Text
                fontFamily={"PlusJakartaSansRegular"}
                fontSize={"14px"}
                color={"#000000"}
                textAlign={"center"}
                marginTop={3}
              >
                All pre-worn items are sent for cleaning (unless they have
                already been cleaned and include the cleaning tags). Kidswear
                Collective has negotiated discounted business rates. Dry
                cleaning costs are £3.95 for garments and £5.50 for outerwear.
                Some items may cost more to clean or repair and if this is the
                case, Kidswear Collective will inform the seller in advance for
                authorisation. Cleaning costs are deducted from the seller’s
                account balance.
              </Text>
              {/* STORAGE */}
              <Text
                fontFamily={"PlusJakartaSansSemiBold"}
                fontSize={"24px"}
                lineHeight={"32px"}
                color={"#000000"}
                textAlign={"center"}
                textTransform={"capitalize"}
                marginTop={8}
              >
                STORAGE
              </Text>
              <Text
                fontFamily={"PlusJakartaSansRegular"}
                fontSize={"14px"}
                color={"#000000"}
                textAlign={"center"}
                marginTop={3}
              >
                All items are professionally photographed and listed on the
                Kidswear Collective website. They are individually listed with
                style descriptions and categorised by various features
              </Text>
              <Text
                fontFamily={"PlusJakartaSansRegular"}
                fontSize={"14px"}
                color={"#000000"}
                textAlign={"center"}
                marginTop={3}
              >
                Sellers send items at their own risk and Kidswear Collective is
                not liable for any damages, loss or theft for items in transit
                or held in storage or off-site at pop-ups, tradeshows or
                cleaners.
              </Text>
              {/* PRICING */}
              <Text
                fontFamily={"PlusJakartaSansSemiBold"}
                fontSize={"24px"}
                lineHeight={"32px"}
                color={"#000000"}
                textAlign={"center"}
                textTransform={"capitalize"}
                marginTop={8}
              >
                PRICING
              </Text>
              <Text
                fontFamily={"PlusJakartaSansRegular"}
                fontSize={"14px"}
                color={"#000000"}
                textAlign={"center"}
                marginTop={3}
              >
                The seller’s share is 50% of the sale price (minus any cleaning,
                collection or return related costs as covered above).
              </Text>
              <Text
                fontFamily={"PlusJakartaSansRegular"}
                fontSize={"14px"}
                color={"#000000"}
                textAlign={"center"}
                marginTop={3}
              >
                Kidswear Collective has full discretion on the sale price for
                each item, which is typically 55% off the original retail price
                and discounts can go up to 80%, depending on the quality of the
                garment and time taken to sell.
              </Text>
              <Text
                fontFamily={"PlusJakartaSansRegular"}
                fontSize={"14px"}
                color={"#000000"}
                textAlign={"center"}
                marginTop={3}
              >
                Kidswear Collective reserves the right to reduce item sale
                prices after a reasonable period of time if they have not sold
                and can continue to reduce prices until such time that they are
                eventually sold. Similarly, if items are subsequently found to
                have stains or damaged they will be removed from inventory.
              </Text>
              {/* PROMOTIONS */}
              <Text
                fontFamily={"PlusJakartaSansSemiBold"}
                fontSize={"24px"}
                lineHeight={"32px"}
                color={"#000000"}
                textAlign={"center"}
                textTransform={"capitalize"}
                marginTop={8}
              >
                PROMOTIONS
              </Text>
              <Text
                fontFamily={"PlusJakartaSansRegular"}
                fontSize={"14px"}
                color={"#000000"}
                textAlign={"center"}
                marginTop={3}
              >
                Items are promoted on Kidswear Collective from time to time and
                any additional discounts (such as discount codes) are deducted
                from Kidswear Collective’s share of the sale proceeds, rather
                than the seller’s.
              </Text>
              {/* PAYMENTS */}
              <Text
                fontFamily={"PlusJakartaSansSemiBold"}
                fontSize={"24px"}
                lineHeight={"32px"}
                color={"#000000"}
                textAlign={"center"}
                textTransform={"capitalize"}
                marginTop={8}
              >
                PAYMENTS
              </Text>
              <Text
                fontFamily={"PlusJakartaSansRegular"}
                fontSize={"14px"}
                color={"#000000"}
                textAlign={"center"}
                marginTop={3}
              >
                Net proceeds from sales (as noted above) will be paid to sellers
                at the end of each month following a 30 day return period.
                Payments will be made by direct bank transfer. Payments will
                typically be paid when account balances are above £50.
              </Text>
              {/* STATEMENTS */}
              <Text
                fontFamily={"PlusJakartaSansSemiBold"}
                fontSize={"24px"}
                lineHeight={"32px"}
                color={"#000000"}
                textAlign={"center"}
                textTransform={"capitalize"}
                marginTop={8}
              >
                STATEMENTS
              </Text>
              <Text
                fontFamily={"PlusJakartaSansRegular"}
                fontSize={"14px"}
                color={"#000000"}
                textAlign={"center"}
                marginTop={3}
              >
                Sellers receive a statement upon request. This includes the
                value of stock received, sold and remaining. It also shows the
                total amount paid out to the seller.
              </Text>
              {/* STATEMENTS */}
              <Text
                fontFamily={"PlusJakartaSansSemiBold"}
                fontSize={"24px"}
                lineHeight={"32px"}
                color={"#000000"}
                textAlign={"center"}
                textTransform={"capitalize"}
                marginTop={8}
              >
                ACCEPTANCE
              </Text>
              <Text
                fontFamily={"PlusJakartaSansRegular"}
                fontSize={"14px"}
                color={"#000000"}
                textAlign={"center"}
                marginTop={3}
              >
                Sending items to Kidswear Collective will be deemed as
                acceptance of the seller’s terms and conditions as listed above.
              </Text>
              <Flex gap={2} mt={4}>
                <Checkbox
                  isChecked={isChecked}
                  iconColor="white"
                  sx={{
                    ".chakra-checkbox__control": {
                      borderColor: "#000",
                    },
                    ".chakra-checkbox__control[data-checked]": {
                      background: "#000",
                      borderColor: "#000",
                    },
                  }}
                  onChange={(e) => setIsChecked(e.target.checked)}
                />
                <Text
                  color={"#000000"}
                  fontFamily={"PlusJakartaSansMedium"}
                  fontSize={"12px"}
                  lineHeight={"18px"}
                >
                  I have read all the Terms and Conditions of KC
                </Text>
              </Flex>
            </VStack>

            <VStack width={"100%"}>
              <Button
                bgColor={isChecked ? "#000" : "#D3D3D3"}
                color={"#FFFFFF"}
                borderRadius={"12px"}
                fontFamily={"PlusJakartaSansSemiBold"}
                fontSize={"16px"}
                lineHeight={"20px"}
                w={"100%"}
                h={"48px"}
                marginTop={3}
                textTransform={'uppercase'}
                onClick={() => navigate("/register")}
                isDisabled={!isChecked}
                _disabled={{
                  cursor: "not-allowed",
                  bgColor: "#D3D3D3", // light gray background
                  color: "#FFFFFF", // white text
                }}
              >
                Next
              </Button>
            </VStack>
          </VStack>
        </Box>

        {/* Right Image */}
        <Box flex={1}>
          <Image
            src={img1}
            alt="Kids Fashion"
            objectFit="cover"
            width={589}
            height={440}
          />
        </Box>
      </Flex>
      <RequestModal onClose={onModalClose} isOpen={isModalOpen} />
    </>
  );
};

export default AuthTermsAndConditions;
